/* eslint-disable */
import DatePicker from "react-datepicker";
import Loader from "../../../components/loader/Loader"
import './Search.scss';
import { useEffect, useState } from "react";
import { TableColumnConfig, TableConfig } from "../../../shared/interfaces/Common";
import moment from "moment";
import { getTableColumnWidth } from "../../../shared/hooks/table";
import { RESPONSE_SUCESS } from "../../../shared/constants/response-constants";
import { IAdvanceSearch } from "../../../shared/interfaces/SearchResult";
import { useNavigate } from "react-router-dom";
import { IsNotNull, toPhoneNumberFormat } from "../../../shared/hooks/utils";
import { APIResponseOfSearchAccountResponse, AccountSearchDTO } from "../../../services/generated";
import MaskedInput from 'react-maskedinput';
import useApi from "../../../hooks/use-api";
import { GridColumn, GridContainer, GridRow } from "../../../components/grid/Grid";
import { Label } from "../../../components/label/Label";
import { Button } from "../../../components/button/Button";
import { Icon } from "../../../components/icon/Icon";
import { Tooltip } from "../../../components/tooltip/Tooltip";
import { Paginator } from "../../../components/paginator/Paginator";
import { Input } from "../../../components/input/Input";
import { Table, TableRow, TableBody, TableHeader, TableColumn } from "../../../components/table/Table";
import { Image } from "../../../components/image/Image";
import '../../../components/data-table/DataTable.scss';

export const AccountSearchTableColumns: Array<TableColumnConfig> = [
    { label: 'Patient', key: 'firstname' , width: 'auto', type: 'string'},
    { label: 'Account #', key: 'accountnumber' , width: 'auto', type: 'link'},
    { label: 'Interactions', key: 'totalInteractions' , width: 'auto', type: 'link'},
    { label: 'COID', key: 'coid' , width: 'auto', type: 'string'},
    { label: 'DOB', key: 'birthDate' , width: 'auto', type: 'string'},
    { label: 'MRN', key: 'medicalRecordNumber' , width: 'auto', type: 'string'},
    { label: 'Cell Phone (Primary/Secondary)', key: 'cellPhone' , width: 'auto', type: 'string'},
    { label: 'Home Phone (Primary/Secondary)', key: 'homePhone' , width: 'auto', type: 'string'}
];
const defaultParams: IAdvanceSearch = {
    AccountNumber: null,
    FirstName: null,
    LastName: null,
    DOB: null,
    MedicalRecordNumber: null,
    ApptURN: null,
    Phonenumber: null,
    IsNewSearch: true,
    COID: null
}
const defaultTableConfig: TableConfig = {
    page: 1,
    pageSize: 15,
    sortColumn: 'accountnumber',
    sortDir: 'desc',
    totalPage: 0
}
function AccountSearch(props: {onCloseBtnClick: any, onMinimizeBtnClick: any}) {
    const columnConfig = getTableColumnWidth(AccountSearchTableColumns);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [isTableLoaded, setIsTableLoaded] = useState<boolean>(false);
    const [searchResults, setSearchResults] = useState<AccountSearchDTO[] | undefined>(undefined);
    const [searchParams, setSearchParams] = useState<IAdvanceSearch>(defaultParams);
    const [appliedSearchParams, setAppliedSearchParams] = useState<IAdvanceSearch>(defaultParams);
    const [searchResultsTableConfig, setSearchResultsTableConfig] = useState<TableConfig>({...defaultTableConfig});
    const [isValidPhoneNumber, setIsValidPhoneNumber] = useState<boolean>(true);
    const navigate = useNavigate();
    const { account: accountClient } = useApi();
    
    const getRouteLink = (accountValues: any): string => {
        let url: string = (IsNotNull(accountValues?.accountnumber)) ? '/account/appointments' : '/account/patient-scheduling';
        url = url + (IsNotNull(accountValues?.accountnumber) ? '?accountNumber=' + accountValues?.accountnumber : '?');
        url = url + (IsNotNull(accountValues?.coid) ? '&coid=' + accountValues?.coid : '');
        url = url + (IsNotNull(accountValues?.mnemonic) ? '&mnemonic=' + accountValues?.mnemonic : '&mnemonic=null');
        return url;
    }

    const onClearSearch = () => {
        setSearchParams(defaultParams);
        setAppliedSearchParams(defaultParams);
        setSearchResults(undefined);
        setSearchResultsTableConfig({...defaultTableConfig});
    }

    const onApplySearch = () => {
        setIsTableLoaded(false);
        setIsLoaded(false); 
        let sParams = searchParams;
        sParams.IsNewSearch = true;
        setSearchParams(sParams);
        setAppliedSearchParams(sParams);
        let config = searchResultsTableConfig;
        config.page = 1;
        config.pageSize = 15;
        config.sortColumn = 'accountnumber';
        config.sortDir = 'desc';
        setSearchResultsTableConfig(config);

        let payload: any = {};
        payload = {...sParams};
        payload.page = config.page;
        payload.pageSize = config.pageSize;
        payload.sortColumn = config.sortColumn;
        payload.sortDir = config.sortDir;
        let loading = searchResultsTableConfig.totalPage !== 0 ? true : false;
        setIsLoaded(loading);
        loadSearchResults(payload);
    }

    const loadSearchResults = async (payload: any) => {
        setIsTableLoaded(false);
        const response: APIResponseOfSearchAccountResponse = await accountClient.advancedSearch(null, payload).catch((error: any) => {
            setIsLoaded(true);
            setSearchResults(undefined)
            return error;
        });
        if (response.statusCode === RESPONSE_SUCESS && response.result && response.result.userDemographics) {
            setSearchResults(response.result.userDemographics);
            let config = searchResultsTableConfig;
            config.totalPage = response.result.total !== null ? response.result.total : searchResultsTableConfig.totalPage;
            setSearchResultsTableConfig({...config});
            setIsLoaded(true);
            setIsTableLoaded(true);
        }
    }

    const updateSearchParams = (field: string, value: string) => {
        let params = {...searchParams};
        switch (field) {
            case 'AccountNumber':
                const upValue = (value === null || value === '') ? null : value.replace(/[^a-zA-Z0-9]/g, '');
                params.AccountNumber = upValue;
                setSearchParams(params);
                break;
            case 'FirstName':
                params.FirstName = value;
                setSearchParams(params);
                break;
            case 'LastName':
                params.LastName = value;
                setSearchParams(params);
                break;
            case 'DOB':
                const birthDate = value !== null ? moment(value).format('MM-DD-YYYY') : null;
                params.DOB = birthDate;
                setSearchParams(params);
                break;
            case 'MedicalRecordNumber':
                const mrValue = (value === null || value === '') ? null : value.replace(/[^a-zA-Z0-9]/g, '');
                params.MedicalRecordNumber = mrValue;
                setSearchParams(params);
                break;
            case 'ApptURN':
                params.ApptURN = value;
                setSearchParams(params);
                break;
            case 'Phonenumber':
                params.Phonenumber = formatPhoneNumber(value);
                setSearchParams(params);
                break;
            case 'COID':
                const coid = value === null ? null : extractNumericValues(value);
                params.COID = coid;
                setSearchParams(params);
                break;
            default:
                setSearchParams(params);
                break;
        }
    }

    const extractNumericValues = (input: string | number): number | null => {
        let params = {...searchParams};
        if (typeof input === 'number') 
            return input;
        if (typeof input !== 'string' && typeof input === 'number') 
            return params.COID;

        const numericValues = input.match(/\d+/g);
        
        if (numericValues) 
            return Number.parseInt(numericValues.join("")); 
        else
            return null; 
    }

    const closeSearchPanel = () => {
        props.onCloseBtnClick(true);
    }

    const minimizeSearchPanel = () => {
        props.onMinimizeBtnClick(true)
    }

    const onClickAccountNumber = (row: any) => {
        navigate(getRouteLink(row));
        minimizeSearchPanel();
    }

    const pageNumberChange = (event: any) => {
        if (searchResultsTableConfig?.page !== event.detail.value) {
            let tableConfig: TableConfig = searchResultsTableConfig;
            tableConfig.page = event.detail.value;
            setSearchResultsTableConfig(tableConfig);
            let sParams = searchParams;
            // sParams.IsNewSearch = false;
            setSearchParams(sParams);

            let payload: any = {};
            payload = {...sParams};
            // payload.IsNewSearch = false;
            payload.page = tableConfig.page;
            payload.pageSize = tableConfig.pageSize;
            payload.sortColumn = tableConfig.sortColumn;
            payload.sortDir = tableConfig.sortDir;
            loadSearchResults(payload);
        }
    };

    const onSortChange = (column: string, dir: any) => {
        if((searchResultsTableConfig?.sortColumn !== column || searchResultsTableConfig.sortDir !== dir) && 
            column !== 'cellPhone' && column !== 'homePhone') {
            setSearchResultsTableConfig(defaultTableConfig);
            let sParams = searchParams;
            // sParams.IsNewSearch = false;
            setSearchParams(sParams);
            let config = searchResultsTableConfig;
            config.page = 1;
            config.pageSize = 15;
            config.sortColumn = column;
            config.sortDir = dir;
            setSearchResultsTableConfig(config);
            let payload: any = {};
            payload = {...sParams};
            payload.page = config.page;
            payload.pageSize = config.pageSize;
            payload.sortColumn = config.sortColumn;
            payload.sortDir = config.sortDir;
            loadSearchResults(payload);
        }
    }

    const formatPhoneNumber = (value: any) => {
        const HomePhno = toPhoneNumberFormat(value);
        if (HomePhno.length === 10 || HomePhno.length === 0) {
            setIsValidPhoneNumber(true);
            let convertHomePh = HomePhno.length === 10 ? HomePhno.substring(0, 3) + '-' + HomePhno.slice(3, 6) + '-' + HomePhno.slice(6, 10) : null;
            return convertHomePh
        } else {
            setIsValidPhoneNumber(false);
            return HomePhno
        }
    }

    useEffect(() => { 
        setIsLoaded(true); 
        setIsTableLoaded(true); 
        setSearchResultsTableConfig({...defaultTableConfig});
        setSearchParams(defaultParams); 
        setAppliedSearchParams(defaultParams);
    },[]);

    return (
        <GridContainer fluid className="result-page-container page-wrapper">
            <GridRow className='h-100 p-0'>
                <GridColumn className='search-field-wrap col-2'>
                    <div className="label-wrap">
                        <Label className="text-medium">Search Fields</Label>
                        {(!searchResults || searchResults?.length === 0) && <span onClick={closeSearchPanel} className="close-search">Close<Icon value="close"></Icon></span>}
                    </div>
                    <div className="pt-3 search-input-wrap">
                        <div className="search-inputs">
                            <div className='mb-1'>
                                <Label className="d-block mb-1">Account Number</Label>
                                <Input onChange={(e: any) => {updateSearchParams('AccountNumber', e.target.value)}} value={searchParams?.AccountNumber}
                                    autocomplete="off"
                                    inputmode="text"
                                    enterkeyhint="search"
                                    autocorrect="off"
                                    type="text"
                                    // placeholder="Search account number"
                                    />
                            </div>
                            <div className='mb-1'>
                                <Label className="d-block mb-1">Patient First Name</Label>
                                <Input onChange={(e: any) => {updateSearchParams('FirstName', e.target.value)}} value={searchParams?.FirstName}
                                    autocomplete="off"
                                    inputmode="text"
                                    enterkeyhint="search"
                                    autocorrect="off"
                                    type="text"
                                    // placeholder="Search patient first name"
                                    />
                            </div>
                            <div className='mb-1'>
                                <Label className="d-block mb-1">Patient Last Name</Label>
                                <Input onChange={(e: any) => {updateSearchParams('LastName', e.target.value)}} value={searchParams?.LastName}
                                    autocomplete="off"
                                    inputmode="text"
                                    enterkeyhint="search"
                                    autocorrect="off"
                                    type="text"
                                    // placeholder="Search patient last name"
                                    />
                            </div>
                            <div className='mb-1'>
                                <Label className="d-block mb-1">Patient Date of Birth</Label>
                                <DatePicker selected={searchParams?.DOB ? new Date(searchParams?.DOB) : null} onChange={(e: any) => {updateSearchParams('DOB', e)}} 
                                    showIcon shouldCloseOnSelect={true} customInput={<MaskedInput mask="11/11/1111" placeholder="mm/dd/yyyy" />} placeholderText="Select date of birth" />
                            </div>
                            <div className='mb-1'>
                                <Label className="d-block mb-1">Patient Phone Number</Label>
                                <MaskedInput className="neu-form__native masked-input" onChange={(e: any) => {updateSearchParams('Phonenumber', e.target.value)}} value={searchParams?.Phonenumber!}
                                    mask="111-111-1111" placeholder="###-###-####" />
                                {(!isValidPhoneNumber && searchParams.Phonenumber != null) ? <div style={{ color: 'red' }}>Please enter a valid phone number.</div> : ''}
                            </div>
                            <div className='mb-1'>
                                <Label className="d-block mb-1">Appt. URN</Label>
                                <Input onChange={(e: any) => {updateSearchParams('ApptURN', e.target.value)}} value={searchParams?.ApptURN}
                                    autocomplete="off"
                                    inputmode="text"
                                    enterkeyhint="search"
                                    autocorrect="off"
                                    type="text"
                                    // placeholder="Search Appt. URN"
                                    />
                            </div>
                            <div className='mb-1'>
                                <Label className="d-block mb-1">MRN</Label>
                                <Input onChange={(e: any) => {updateSearchParams('MedicalRecordNumber', e.target.value)}} value={searchParams?.MedicalRecordNumber}
                                    autocomplete="off"
                                    inputmode="text"
                                    enterkeyhint="search"
                                    autocorrect="off"
                                    type="text"
                                    // placeholder="Search MRN"
                                    />
                            </div>
                            <div className='mb-1'>
                                <Label className="d-block mb-1">COID</Label>
                                <Input onChange={(e: any) => {updateSearchParams('COID', e.target.value)}} value={searchParams?.COID}
                                    autocomplete="off"
                                    inputmode="text"
                                    enterkeyhint="search"
                                    autocorrect="off"
                                    type="text"
                                    // placeholder="Search COID"
                                    />
                            </div>
                        </div>
                        <div className="controls">
                            <Button onClick={() => onClearSearch()} color="blue" fillType="secondary">Clear Search</Button>
                            <Button disabled={
                                ( (searchParams.AccountNumber === null || searchParams.AccountNumber === '') && 
                                (searchParams.FirstName === null || searchParams.FirstName === '') &&
                                (searchParams.LastName === null || searchParams.LastName === '') && 
                                (searchParams.DOB === null || searchParams.DOB === '') &&
                                (searchParams.MedicalRecordNumber === null || searchParams.MedicalRecordNumber === '') && 
                                (searchParams.ApptURN === null || searchParams.ApptURN === '') && 
                                (searchParams.COID === null) &&
                                (searchParams.Phonenumber === null || searchParams.Phonenumber === '')) || (!isValidPhoneNumber && searchParams.Phonenumber !== null) || (!isTableLoaded || !isLoaded)
                            } onClick={() => onApplySearch()} color="blue" fillType="primary">Apply Search</Button> 
                        </div>
                    </div>
                    
                </GridColumn>
                <GridColumn className='search-results-table-wrap col-10'>
                    {searchResultsTableConfig?.totalPage ? 
                        <> 
                            {   searchResultsTableConfig?.totalPage > 0 ? 
                                <div className="mb-2 d-flex justify-content-between">
                                    <div className="text-start search-count">{searchResultsTableConfig?.totalPage + ' Results'}</div>
                                    <div className="d-flex">
                                        <span onClick={minimizeSearchPanel} className="close-search minimize-btn"><Icon value="remove" /></span>
                                        <span onClick={closeSearchPanel} className="close-search close-btn"><Icon value="close" /></span>
                                    </div>
                                </div>
                                 : ''
                            }
                        </> : ''
                    }
                    {searchResults && <div>
                        <div className={searchResults?.length === 0 ? 'table-outer no-data' : 'table-outer'}>
                            <div className={ isLoaded ? 'table-wrapper' :  'table-wrapper loader-active'}>
                                {<div className={searchResults.length === 15 ? 'table-inner' : 'table-inner auto-height'}>
                                    <Table>
                                        <TableHeader>
                                            <TableRow columns={columnConfig} header={true}>
                                                {
                                                    AccountSearchTableColumns.map((header: any, columnKey) => (
                                                        <TableColumn sort={header.key === 'cellPhone' || header.key === 'homePhone' ? false : true} className={header.key} key={columnKey} direction={searchResultsTableConfig?.sortColumn === header.key ? searchResultsTableConfig?.sortDir : 'none'}
                                                            onClickTableColumn={() => onSortChange(header.key, searchResultsTableConfig?.sortColumn === header.key && searchResultsTableConfig?.sortDir === 'desc' ? 'asc' : 'desc')} >
                                                            <Label>{header.label}</Label>
                                                            { header.key === 'medicalRecordNumber' && 
                                                                <Tooltip className="style-1-tooltip" tip="Medical Record Number">
                                                                    <Icon className="table-header-icon" value="help" />
                                                                    {/* <div slot="tooltip"></div> */}
                                                                </Tooltip>}
                                                        </TableColumn>
                                                    ))
                                                }
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody>
                                            <div className="table-data-inner">
                                                <TableRow className={isTableLoaded ? 'd-none' : 'loader-row'} rowspan={AccountSearchTableColumns.length}>
                                                    <Loader/>
                                                </TableRow>
                                                { 
                                                    searchResults?.map((row: any, index) => (
                                                        <TableRow className={isTableLoaded ? '' : 'd-none'}  columns={columnConfig} key={index}>
                                                            {
                                                                AccountSearchTableColumns.map((header, column) => (
                                                                    <TableColumn className={header.key} key={column} id={header.key}>
                                                                        { header.key === 'firstname' &&
                                                                            <span className='cursor-pointer table-data' onClick={() => onClickAccountNumber(row)}>
                                                                                {appliedSearchParams.LastName !== null && <span className="link text-medium">{row['lastname'].substring(row['lastname'].indexOf(appliedSearchParams.LastName), appliedSearchParams.LastName?.length)}</span>}
                                                                                {IsNotNull(row[header.key]) && <span>{row['lastname'].substring(appliedSearchParams.LastName?.length, row['lastname'].length)}</span>}&nbsp;
                                                                                {appliedSearchParams.FirstName !== null && <span className="link text-medium">{' ' + row['firstname'].substring(row['firstname'].indexOf(appliedSearchParams.FirstName), appliedSearchParams.FirstName?.length)}</span>}
                                                                                {IsNotNull(row[header.key]) && <span>{row['firstname'].substring(appliedSearchParams.FirstName?.length, row['firstname'].length)}</span>}
                                                                            </span>
                                                                        }
                                                                        { header.key === 'accountnumber' && 
                                                                            <span onClick={() => onClickAccountNumber(row)} className='cursor-pointer table-data'>
                                                                                {IsNotNull(row[header.key]) && <>
                                                                                    {appliedSearchParams.AccountNumber !== null && <span>{row[header.key].substring(0, row[header.key].indexOf(appliedSearchParams.AccountNumber))}</span>}
                                                                                    {appliedSearchParams.AccountNumber !== null && <span className="link text-medium">{row[header.key].substring(row[header.key].indexOf(appliedSearchParams.AccountNumber), row[header.key].indexOf(appliedSearchParams.AccountNumber) + appliedSearchParams.AccountNumber?.length)}</span>}
                                                                                    {<span>{row[header.key].substring(row[header.key].indexOf(appliedSearchParams.AccountNumber) + appliedSearchParams.AccountNumber?.length, row[header.key].length)}</span>}
                                                                                </>}
                                                                            </span>
                                                                        }
                                                                        { header.key === 'totalInteractions' && 
                                                                            <span className='table-data'>
                                                                                {<span>{row[header.key]}</span>}
                                                                            </span>
                                                                        }
                                                                        { header.key === 'birthDate' && 
                                                                            <span className='table-data'>
                                                                                {appliedSearchParams.DOB !== null && <span className="link text-medium">{row[header.key].substring(row[header.key].indexOf(appliedSearchParams.DOB), appliedSearchParams.DOB?.length)}</span>}
                                                                                {IsNotNull(row[header.key]) && <span>{row[header.key].substring(appliedSearchParams.DOB?.length, row[header.key].length)}</span>}
                                                                            </span>
                                                                        }
                                                                        { header.key === 'medicalRecordNumber' && 
                                                                            <span className='table-data'>
                                                                                {appliedSearchParams.MedicalRecordNumber !== null && <span className="link text-medium">{row[header.key].substring(row[header.key].indexOf(appliedSearchParams.MedicalRecordNumber), appliedSearchParams.MedicalRecordNumber?.length)}</span>}
                                                                                {IsNotNull(row[header.key]) && <span>{row[header.key].substring(appliedSearchParams.MedicalRecordNumber?.length, row[header.key].length)}</span>}
                                                                            </span>
                                                                        }
                                                                        { header.key === 'coid' && 
                                                                            <span className='table-data'>
                                                                                {IsNotNull(row[header.key]) && <span>{row[header.key]}</span>}
                                                                            </span>
                                                                        }
                                                                        { (header.key === 'cellPhone') && 
                                                                            <span className='table-data'>
                                                                                { row['primaryCellPhone'] !== null && <>
                                                                                    {
                                                                                        appliedSearchParams.Phonenumber === row['primaryCellPhone'] ? <span className="link text-medium">{row['primaryCellPhone']}</span>
                                                                                        : <span>{row['primaryCellPhone']}</span>
                                                                                    }  </>
                                                                                }
                                                                                { row['secondaryCellPhone'] !== null && <>/&nbsp;
                                                                                    { 
                                                                                        appliedSearchParams.Phonenumber === row['secondaryCellPhone'] ? <span className="link text-medium">{row['secondaryCellPhone']}</span>
                                                                                        : <span>{row['secondaryCellPhone']}</span>
                                                                                    }  </>
                                                                                }
                                                                            </span>
                                                                        }
                                                                        { (header.key === 'homePhone') && 
                                                                            <span className='table-data'>
                                                                                { row['primaryHomePhone'] !== null && <>
                                                                                    {
                                                                                        appliedSearchParams.Phonenumber === row['primaryHomePhone'] ? <span className="link text-medium">{row['primaryHomePhone']}</span>
                                                                                        : <span>{row['primaryHomePhone']}</span>
                                                                                    }  </>
                                                                                }
                                                                                { row['secondaryHomePhone'] !== null && <>/&nbsp;
                                                                                    { 
                                                                                        appliedSearchParams.Phonenumber === row['secondaryHomePhone'] ? <span className="link text-medium">{row['secondaryHomePhone']}</span>
                                                                                        : <span>{row['secondaryHomePhone']}</span>
                                                                                    }  </>
                                                                                }
                                                                            </span>
                                                                        }
                                                                    </TableColumn>
                                                                ))
                                                            }
                                                        </TableRow>
                                                    )) 
                                                }
                                                <TableRow className={searchResults.length === 0 && isTableLoaded ? 'no-data-row' : 'd-none'} rowspan={AccountSearchTableColumns.length}>
                                                    <div className='no-data-message'>
                                                        <Image src="/assets/icons/SearchIcon.svg" alt="Search"/>
                                                        <Label>No Search Results</Label> 
                                                    </div>
                                                </TableRow>
                                            </div>
                                        </TableBody>
                                    </Table>
                                </div>}
                            </div>
                        </div>
                        <div className='table-paginator text-end w-100 mt-2'>
                        { (searchResultsTableConfig?.totalPage && searchResultsTableConfig?.totalPage > 0) ? 
                            <Paginator total={searchResultsTableConfig.totalPage} size={searchResultsTableConfig.pageSize} page={searchResultsTableConfig.page} onChange={pageNumberChange} />
                            : ''
                        }
                        </div>
                    </div>}
                    {!isLoaded && 
                        <div className="search-page-loader">
                            <Loader/>
                        </div>
                    }
                </GridColumn>
            </GridRow>
        </GridContainer>
    )
}
export default AccountSearch;